<div class="flex items-center justify-center p-6">

  <div class="w-full max-w-2xl overflow-hidden">
    <div class="p-8">
      <div class="mb-8 text-center">
        <p class="text-4xl font-bold text-blue-600">₹ 500</p>
        <p class="text-gray-500 text-sm mt-1">Amount to be Paid</p>
      </div>
      <div class="bg-gray-50 p-4 rounded-xl border border-gray-200 mb-8">
        <h3 class="font-semibold text-gray-800 mb-3 text-sm">Re-Evaluation Details</h3>
        <div class="grid grid-cols-2 gap-y-2 text-gray-700 text-sm">
          <p><span class="font-medium">Roll No:</span> 12345</p>
          <p><span class="font-medium">Subject:</span> English (001)</p>
          <p><span class="font-medium">Total Marks:</span> 100</p>
          <p><span class="font-medium">Marks Obtained:</span> 28</p>
          <p><span class="font-medium">Result:</span> Failed</p>
          <p><span class="font-medium">Fees:</span> ₹ 500</p>
        </div>
      </div>
      <h3 class="font-semibold text-gray-800 mb-3 text-sm">Choose Payment Method</h3>
      <div class="space-y-3 mb-8">
        <label (click)="openSection('card')"
          class="flex items-center gap-3 p-3 border rounded-xl hover:bg-gray-50 cursor-pointer">
          <input type="radio" name="payment" class="scale-125" />
          <img src="https://upload.wikimedia.org/wikipedia/commons/4/41/Visa_Logo.png" class="h-6">
          <span class="text-gray-700">Credit / Debit Card</span>
        </label>
        <div id="card-section" [class.hidden]="activeSection !== 'card'"
          class="border rounded-xl p-4 bg-gray-50 hidden">
          <label class="text-gray-700 text-sm">Card Number</label>
          <input type="text" class="w-full border rounded-lg p-2 mt-1 mb-3" placeholder="XXXX XXXX XXXX XXXX">
          <div class="grid grid-cols-2 gap-3">
            <div>
              <label class="text-gray-700 text-sm">Expiry Date</label>
              <input type="text" class="w-full border rounded-lg p-2 mt-1" placeholder="MM/YY">
            </div>
            <div>
              <label class="text-gray-700 text-sm">CVV</label>
              <input type="password" class="w-full border rounded-lg p-2 mt-1" placeholder="***">
            </div>
          </div>
        </div>
        <label (click)="openSection('upi')"
          class="flex items-center gap-3 p-3 border rounded-xl hover:bg-gray-50 cursor-pointer">
          <input type="radio" name="payment" class="scale-125" />
          <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/UPI-Logo-vector.svg" class="h-6">
          <span class="text-gray-700">UPI (GPay / PhonePe / Paytm)</span>
        </label>
        <div id="upi-section" [class.hidden]="activeSection !== 'upi'" class="border rounded-xl p-4 bg-gray-50 hidden">
          <label class="text-gray-700 text-sm">Enter UPI ID</label>
          <input type="text" class="w-full border rounded-lg p-2 mt-1" placeholder="yourname@upi">
        </div>
        <label (click)="openSection('wallet')"
          class="flex items-center gap-3 p-3 border rounded-xl hover:bg-gray-50 cursor-pointer">
          <input type="radio" name="payment" class="scale-125" />
          <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/Paytm_logo.png" class="h-7">
          <span class="text-gray-700">Wallet - Paytm</span>
        </label>
        <div id="wallet-section" [class.hidden]="activeSection !== 'wallet'"
          class="border rounded-xl p-4 bg-gray-50 hidden">
          <label class="text-gray-700 text-sm">Paytm Number</label>
          <input type="text" class="w-full border rounded-lg p-2 mt-1" placeholder="Enter Paytm Mobile Number">
        </div>
      </div>
      <div class="flex justify-end items-center gap-10">
        <app-button color="bg-gray-200 text-gray-700" routerLink="/student-portal/list" label=" Back To Website"
          type="button"></app-button>
        <app-button color="bg-primary text-white" (click)="open_recipt.open()" routerLink="/payment-page"
          label="Pay ₹ 500" type="button"></app-button>
      </div>
    </div>
  </div>
</div>
<app-modal #open_recipt label="Payment Successful" width="auto" [is_mandatory]="true">
  <p class="text-gray-700 leading-relaxed mb-8 w-96">
    Your payment has been successfully processed. Thank you for submitting your
    re-evaluation request. Please make sure to keep a copy of your receipt for
    future reference. You may now return to the website or download your receipt.
  </p>
  <div class="space-y-3 text-gray-800 text-sm mb-10">
    <p><span class="font-semibold">Program:</span> Semester 1</p>
    <p><span class="font-semibold">Subject:</span> Maths</p>
    <p><span class="font-semibold">Examination Date:</span> 12 August 2025</p>

    <p class="text-lg font-semibold mt-4">
      Re-Evaluation Fees: ₹ 500
    </p>
  </div>
  <div class="flex items-center justify-end gap-5">
    <app-button color="bg-gray-200 text-gray-700" routerLink="/student-portal/list" label="Back To Website"
          type="button"></app-button>
        <app-button color="bg-primary text-white" (click)="printReceipt()" routerLink="/payment-page"
          label="Print Receipt" type="button"></app-button>
  </div>
</app-modal>